import { createAction, props } from '@ngrx/store';

// ------------------- Main ------------------- //

export const setFirebaseUser = createAction(
  '[Firebase] Set current firebase user',
  props<{ user: any }>()
);
